import { currentUser } from '../../../utilities/firestore';
import postToFirebaseFunction from '../../../utilities/postToFirebaseFunction';
export default async function cancelSmokeTest({
  appId,
  buildId,
  userId,
}: {
  appId: string;
  buildId: string;
  userId: string;
}) {
  await postToFirebaseFunction('cancelSmokeTest_HTTP', {
    appId,
    buildId,
    userId,
    idToken: await currentUser()?.getIdToken(),
  });
}
